import { Button, Stack, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';

import { CLIENT_TYPES, FactFindType } from '@zeta-types';
import { RouterLinks } from '../../../advisor-route-paths';

const FactFindFooter = ({
  handleClick,
  done,
  hideSave = false,
  handleDone,
  isManagedClient = false,
  from,
  hideNextStep,
  isReadOnly,
}: {
  handleClick?: (this: Window, ev: SubmitEvent) => any;
  done?: boolean;
  hideSave?: boolean;
  handleDone?: () => void;
  isManagedClient?: boolean;
  from: FactFindType;
  hideNextStep?: boolean;
  isReadOnly?: boolean;
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { pathname, state } = useLocation();

  const nextConfig = {
    [RouterLinks.factFindInitialMeetingSummary]: RouterLinks.factFindRiskAssessment,
    [RouterLinks.factFindRiskAssessment]: RouterLinks.factFindPersonalInfo,
    [RouterLinks.factFindPersonalInfo]: RouterLinks.factFindIncome,
    [RouterLinks.factFindIncome]: RouterLinks.factFindExpenditure,
    [RouterLinks.factFindExpenditure]: RouterLinks.factFindAssets,
    [RouterLinks.factFindAssets]: RouterLinks.factFindLiabilites,
    [RouterLinks.factFindLiabilites]: RouterLinks.factFindHealthDetails,
    [RouterLinks.factFindHealthDetails]: RouterLinks.factFindBeneficiaries,
    [RouterLinks.factFindBeneficiaries]: RouterLinks.factFindBenefitsAndInsurance,
    [RouterLinks.factFindBenefitsAndInsurance]: RouterLinks.factFindFinancialPlanning,
    [RouterLinks.factFindFinancialPlanning]: RouterLinks.factFindSummaryAndNotes,
  };

  const nextConfigClient = {
    [RouterLinks.managedClientInitialMeetingSummary]: RouterLinks.managedClientRiskAssessment,
    [RouterLinks.managedClientRiskAssessment]: RouterLinks.managedClientPersonalInfo,
    [RouterLinks.managedClientPersonalInfo]: RouterLinks.managedClientIncome,
    [RouterLinks.managedClientIncome]: RouterLinks.managedClientExpenditure,
    [RouterLinks.managedClientExpenditure]: RouterLinks.managedClientAssets,
    [RouterLinks.managedClientAssets]: RouterLinks.managedClientLiabilites,
    [RouterLinks.managedClientLiabilites]: RouterLinks.managedClientHealthDetails,
    [RouterLinks.managedClientHealthDetails]: RouterLinks.managedClientNominees,
  };

  const nextConfigBusiness = {
    [RouterLinks.factFindInitialMeetingSummary]: RouterLinks.factFindBusinessDetails,
    [RouterLinks.factFindBusinessDetails]: RouterLinks.factFindBusinessKeyMembers,
    [RouterLinks.factFindBusinessKeyMembers]: RouterLinks.factFindBusinessFinancialInformation,
    [RouterLinks.factFindBusinessFinancialInformation]: RouterLinks.factFindBusinessLoans,
    [RouterLinks.factFindBusinessLoans]: RouterLinks.factFindBusinessAssetsPremise,
    [RouterLinks.factFindBusinessAssetsPremise]: RouterLinks.factFindBusinessProfessionalAdvisors,
    [RouterLinks.factFindBusinessProfessionalAdvisors]: RouterLinks.factFindBusinessPensions,
    [RouterLinks.factFindBusinessPensions]: RouterLinks.factFindBusinessCovers,
    [RouterLinks.factFindBusinessCovers]: RouterLinks.factFindBusinessEmployeeBenefits,
    [RouterLinks.factFindBusinessEmployeeBenefits]: RouterLinks.factFindFinancialPlanning,
    [RouterLinks.factFindFinancialPlanning]: RouterLinks.factFindSummaryAndNotes,
  };

  const getConfig = () => {
    if (state?.clientData?.clientType === CLIENT_TYPES.PERSON && !isManagedClient) return nextConfig;
    else if (state?.clientData?.clientType === CLIENT_TYPES.BUSINESS && !isManagedClient) return nextConfigBusiness;
    else if (state?.clientData?.clientType === CLIENT_TYPES.PERSON && isManagedClient) return nextConfigClient;
    else return nextConfig;
  };

  return (
    <Stack
      sx={{
        position: 'fixed',
        bottom: 0,
        zIndex: 2,
        top: 'auto',
        bgcolor: theme.palette.background.default,
        height: 80,
        left: 0,
        right: 0,
        px: 5,
        py: 2,
        boxShadow: theme.shadows[2],
      }}
    >
      <Stack sx={{ height: '100%', width: '100%' }} direction="row" justifyContent="end" alignItems="center" gap={2}>
        {!hideSave && !isReadOnly && (
          <Button
            variant="soft"
            color="inherit"
            size="large"
            id="save-information-button"
            type="submit"
            onClick={(e) => {
              if (handleClick) {
                handleClick(e);
              }
            }}
          >
            Save Information
          </Button>
        )}
        {done ? (
          <Button variant="contained" color="inherit" size="large" onClick={handleDone} id="done-button">
            Done
          </Button>
        ) : (
          <>
            {!hideNextStep && (
              <Button
                variant="contained"
                id="next-step-button"
                color="inherit"
                size="large"
                onClick={() => {
                  if (from === FactFindType.AI) {
                    navigate(RouterLinks.clientDetailsCheckList, { state });
                  }
                  if (from === FactFindType.FACT_FIND) {
                    const next = getConfig();
                    navigate(next[pathname], { state });
                  }
                }}
              >
                Next Step
              </Button>
            )}
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default FactFindFooter;
